<template>
  <section>
    <sys-dialog v-show="dialogVisible" :bgi="dialogBgi" :close-image="closeImageUrl" :show-close="true" :error-msg="errorMsg" @close="closeDialog" />
    <sys-loading :loading="loading" />
    <div class="container" v-if="!isMobile">
      <div class="left">
        <img class="logo" src="../assets/8day-logo.png" />
        <img class="title" src="../assets/sinh/img-title.png" />
        <img class="text" src="../assets/sinh/img-text-pc.png" />
        <div class="form">
          <div class="tag">
            <div class="tag-item reg" :class="isRegisterAction ? 'active' : ''" @click="isRegisterAction = true">
              ĐĂNG KÝ
            </div>
            <div class="tag-item login" :class="!isRegisterAction ? 'active' : ''" @click="isRegisterAction = false">
              ĐĂNG NHẬP
            </div>
          </div>
          <div class="form-input">
            <img src="../assets/sport/icon-user.png" />
            <input v-model="form.userName" placeholder="Tên đăng nhập" maxlength="20" autocomplete="off" />
          </div>
          <div class="form-input" v-show="isRegisterAction">
            <img src="../assets/sport/icon-phone.png" />
            <input v-model="form.phone" placeholder="Số điện thoại" maxlength="10" oninput="value=value.replace(/^\D/, '')" />
          </div>
          <div class="form-input" :style="!isRegisterAction ? { marginBottom: 0 } : ''">
            <img src="../assets/sport/icon-password.png" />
            <input v-model="form.password" type="password" autocomplete="new-password" placeholder="Mật khẩu" />
          </div>
          <div class="form-input" v-show="isRegisterAction">
            <img src="../assets/sport/icon-email.png" />
            <input v-model="form.email" autocomplete="off" placeholder="Email" />
          </div>
          <div class="form-input" v-show="isRegisterAction" style="margin-bottom: 0;position: relative;">
            <input v-model="form.verificationCode" autocomplete="off" maxlength="4" />
            <div class="codeImg">
              <span @click="getVerify" v-if="codeImg" class="validateCode">
                <img class="img" :src="codeImg" alt="code" />
              </span>
            </div>
          </div>
          <a v-if="!isRegisterAction" href="https://www.8day.com">Quên mật khẩu ?</a>
          <v-captcha ref="vcaptcha1" :dialogVisible="dialogVisible" :showCheck="showCheck" :vstyle="{
              padding: '30px 30px 0',
              position: 'relative',
              'box-sizing': 'border-box'
            }" @cb="handleConfirm">
            <div v-show="isRegisterAction" class="btn btn-reg" @click="submitAction(1)">
              <span>ĐĂNG KÝ</span>
            </div>
          </v-captcha>
          <div v-show="!isRegisterAction" class="btn" @click="submitAction(2)">
            ĐĂNG NHẬP
          </div>
        </div>
      </div>
      <div class="right">
        <div class="loop">
          <swiper ref="rightSlide" :options="swiperOptions2">
            <swiper-slide>
              <a href="https://vnn8d.com/" target="_blank">
                <img src="../assets/sinh/img-swiper1.png" alt="" width="100%" />
              </a>
            </swiper-slide>
          </swiper>
          <div class="prev-btn2 nav-btn" slot="button-prev"></div>
          <div class="next-btn2 nav-btn" slot="button-next"></div>
        </div>
        <img class="swiper-btm" src="../assets/sinh/img-swiper-btm.png" />
      </div>
    </div>
    <div class="root" v-if="isMobile">
      <img class="logo" src="../assets/8day-logo.png" />
      <img class="title" src="../assets/sinh/img-title.png" />
      <img class="text" src="../assets/sinh/img-text.png" />
      <div class="tag">
        <div class="tag-item reg" :class="isRegisterAction ? 'active' : ''" @click="isRegisterAction = true">
          ĐĂNG KÝ
        </div>
        <div class="tag-item login" :class="!isRegisterAction ? 'active' : ''" @click="isRegisterAction = false">
          ĐĂNG NHẬP
        </div>
      </div>
      <div class="form">
        <div class="form-input">
          <img src="../assets/sport/icon-user.png" />
          <input v-model="form.userName" placeholder="Tên đăng nhập" maxlength="20" autocomplete="off" />
        </div>
        <div class="form-input" v-show="isRegisterAction">
          <img src="../assets/sport/icon-phone.png" />
          <input v-model="form.phone" placeholder="Số điện thoại" maxlength="10" oninput="value=value.replace(/^\D/, '')" />
        </div>
        <div class="form-input" :style="!isRegisterAction ? { marginBottom: 0 } : ''">
          <img src="../assets/sport/icon-password.png" />
          <input v-model="form.password" type="password" autocomplete="new-password" placeholder="Mật khẩu" />
        </div>
        <div class="form-input" v-show="isRegisterAction">
          <img src="../assets/sport/icon-email.png" />
          <input v-model="form.email" autocomplete="off" placeholder="Email" />
        </div>
        <div class="form-input" v-show="isRegisterAction" style="margin-bottom: 0;position: relative;">
          <input v-model="form.verificationCode" autocomplete="off" maxlength="4" />
          <div class="codeImg">
            <span @click="getVerify" v-if="codeImg" class="validateCode">
              <img class="img" :src="codeImg" alt="code" />
            </span>
          </div>
        </div>
        <a v-if="!isRegisterAction" href="https://www.8day.com">Quên mật khẩu ?</a>
        <v-captcha ref="vcaptcha2" :dialogVisible="dialogVisible" :showCheck="showCheck" :vstyle="{
            padding: '30px 30px 0',
            position: 'relative',
            'box-sizing': 'border-box'
          }" @cb="handleConfirm">
          <div v-show="isRegisterAction" class="btn btn-reg" @click="submitAction(1)">
            <span>ĐĂNG KÝ</span>
          </div>
        </v-captcha>
        <div v-show="!isRegisterAction" class="btn" @click="submitAction(2)">
          ĐĂNG NHẬP
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import md5 from "js-md5";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import {
  FORM_VALID_MESSAGE,
  DOMAIN_AGENT_CODE,
  CONTRACTS
} from "../utils/constant";
import { userRegister, userLogin, createCustomer, getCode } from "../utils/request";
import { encodePlatformUrl, validForm, isMobile } from "../utils/tools";
import { captcha } from "@/mixins/captcha";
export default {
  name: "Sinh",
  mixins: [captcha],
  components: { swiper, swiperSlide },
  data() {
    return {
      codeImg: '',
      isMobile: isMobile(),
      loading: false,
      isRegisterAction: true,
      dialogVisible: false,
      dialogBgi: require("../assets/sinh/bgi-dialog.png"),
      closeImageUrl: require("../assets/sinh/icon-close.png"),
      contacts: CONTRACTS,
      form: {
        by: 1,
        username: "",
        userName: "",
        verificationCode: "",
        phone: "",
        password: "",
        email: "",
        link: "",
        domain: "",
        inviteCode: null
      },
      errorMsg: {
        title: "",
        content: ""
      },
      swiperOptions2: {
        speed: 1000,
        loop: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        },
        effect: "slide",
        navigation: {
          nextEl: ".next-btn2",
          prevEl: ".prev-btn2"
        }
      }
    };
  },
  mounted() {
    window.onresize = () => {
      this.isMobile = isMobile();
    };
    this.getVerify();
  },
  methods: {
    getVerify() {
      getCode({}).then(res => {
        this.codeImg = res.body.data
      })
    },
    submitAction(type) {
      let errorMsg = validForm(type, this.form);
      if (Object.keys(errorMsg).length !== 0) {
        this.setDialogMsg(errorMsg.title, errorMsg.content);
        return;
      }
      this.loading = true;
      // 登陆
      if (type == 2) {
        let temp = Object.assign({}, this.form);
        let params = {
          acctType: 6,
          by: 1,
          email: temp.email,
          userName: temp.userName,
          phone: temp.phone,
          password: md5(temp.password)
        };
        this.login(params);
      } else {
        const inviteCode = DOMAIN_AGENT_CODE[location.host] || "";
        this.form.inviteCode = inviteCode;
        this.form.domain = location.host;
        this.form.username = this.form.userName;
        this.register();
      }
    },
    login(params) {
      userLogin(params)
        .then(res => {
          if (res.data.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.loggedTitle,
              FORM_VALID_MESSAGE.loggedMsg
            );
            setTimeout(() => {
              location.href = encodePlatformUrl(
                params.userName,
                params.password
              );
            }, 5000);
          } else {
            this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, res.data.msg);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, error.data);
          this.loading = false;
        });
    },
    register() {
      let params = (this.params = Object.assign({}, this.form));
      if (!/^[0-9a-zA-Z!~!@#$%^&*.,?]{6,15}$/.test(params.password)) {
        this.setDialogMsg(
          FORM_VALID_MESSAGE.registerFailTitle,
          FORM_VALID_MESSAGE.passwordMsg
        );
        this.loading = false;
        return;
      }
      this.handleCheck(this.handleConfirm);
    },
    handleConfirm(params = this.params) {
      params.userName = params.userName.toLowerCase();
      params.password = md5(params.password);
      params.verificationCode = this.form.verificationCode;
      userRegister(params, this.captchaParams)
        .then(res => {
          if (res.data.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerTitle,
              FORM_VALID_MESSAGE.registerMsg
            );
            createCustomer(this.form);
            setTimeout(() => {
              location.href = encodePlatformUrl(
                params.userName,
                params.password
              );
            }, 5000);
          } else {
            this.getVerify();
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerFailTitle,
              res.data.msg
            );
            this.handleOpen(res.data.code);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.registerFailTitle, error.data);
          this.loading = false;
        });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    setDialogMsg(title, msg) {
      this.errorMsg.title = title;
      this.errorMsg.content = msg;
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  // height: 100vh;
  background-image: url("../assets/sinh/bgi-pc.jpg");
  background-size: 100% 100%;
  overflow: hidden;

  .left {
    width: 62%;
    height: 100%;
    float: left;
    text-align: center;
    display: flex;
    flex-flow: column;
    align-items: center;

    img.logo {
      width: 11vw;
      margin-top: 2vw;
    }

    img.title {
      width: 31.77vw;
    }

    img.text {
      width: 41.35vw;
    }

    .form {
      background-image: url("../assets/sport/bgi-form.png");
      background-size: 100% 100%;
      position: relative;
      width: 27.6563vw;
      margin: 60px auto 0;
      padding-top: 70px;
      padding-bottom: 10px;
      position: relative;

      a {
        color: #00ffe6;
        position: relative;
        top: 20px;
      }

      .tag {
        width: 100%;
        height: 4.375vw;
        line-height: 40px;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        position: absolute;
        top: -2vw;

        .tag-item {
          width: 40%;
          height: 3.4895vw;
          color: #ffffff;
          font-size: 20px;
          font-style: normal;
          font-weight: bold;
          line-height: 3.4895vw;
          cursor: pointer;
          background-image: url("../assets/sinh/bgi-tag.png");
          background-size: 100% 100%;
        }

        .active {
          background-image: url("../assets/sinh/bgi-tag-act.png");
          background-size: 100% 100%;
          width: 55.7%;
          height: 4.375vw;
          line-height: 4.375vw;
          font-size: 30px;
        }
      }

      .form-input {
        width: 70%;
        margin: 0 auto 20px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 10px 20px;
        background-size: 100% 100%;
        transition: all 0.25s ease;
        border-radius: 15px;
        background: rgba(255, 255, 255, 0.2);

        .codeImg {
          cursor: pointer;
          height: 100%;
          position: absolute;
          right: 0;
          top: 1px;
          .img {
            margin-right: 0;
            height: 100%;
            border-radius: 15px;
          }
        }

        img {
          margin-right: 10px;
        }

        input {
          border: none;
          outline-width: 0;
          background-color: transparent;
          height: 34px;
          width: 300px;
          font-family: UTMAvo;
          font-weight: 500;
          font-size: 25px;
          color: #fff;
          padding: 1px 2px;
        }

        input::placeholder {
          color: #ffffff;
          font-size: 22px;
          font-style: normal;
          font-weight: normal;
        }
      }

      .btn {
        width: 17.7vw;
        height: 3.91vw;
        line-height: 2.9vw;
        margin: 0 auto;
        background-image: url("../assets/sinh/bgi-btn.png");
        background-size: 100% 100%;
        font-size: 30px;
        font-weight: bold;
        color: #ffffff;
        cursor: pointer;
        position: relative;
        top: 2vw;
        &:active {
          top: 43px;
        }
      }
    }
  }

  .right {
    width: 38%;
    height: 100%;
    float: right;
    display: flex;
    flex-flow: column;
    justify-content: center;

    .loop {
      width: 471px;
      height: 669px;
      background-image: url("../assets/sinh/bgi-swiper.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      text-align: center;
      position: relative;
      left: 35px;
      cursor: pointer;

      .swiper-container {
        img {
          width: 426px;
          height: 615px;
          margin-top: 27px;
        }
      }

      .nav-btn {
        width: 56px;
        height: 56px;
        position: absolute;
        top: 32.657417vh;
      }

      .prev-btn1,
      .prev-btn2 {
        left: -70px;
        background-image: url("../assets/sinh/icon-left.png");
        background-size: 100% 100%;
      }

      .next-btn1,
      .next-btn2 {
        right: -70px;
        background-image: url("../assets/sinh/icon-right.png");
        background-size: 100% 100%;
      }
    }

    img.swiper-btm {
      width: 28.645833vw;
      margin-top: 2vw;
    }
  }
}
.root {
  width: 100%;
  height: 100vh;
  background-image: url("../assets/sinh/bgi-mb.png");
  background-size: 100% 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  padding-bottom: 2vh;

  img.logo {
    width: 29.21vw;
    margin-top: 3vh;
  }

  img.title {
    margin-top: 3vh;
    width: 80%;
  }

  img.text {
    width: 90%;
  }

  .tag {
    margin-top: 3vw;
    display: flex;
    align-items: flex-end;
    line-height: 40px;
    position: relative;
    top: 7vw;
    z-index: 999;

    .tag-item {
      width: 31.87vw;
      height: 8.9333vw;
      background-image: url("../assets/sinh/bgi-tag.png");
      background-size: 100% 100%;
      color: #ffffff;
      font-size: 1em;
      text-align: center;
      font-style: normal;
      font-weight: bold;
    }

    .active {
      width: 35.87vw;
      height: 11.2vw;
      background-image: url("../assets/sinh/bgi-tag-act.png");
      background-size: 100% 100%;
      line-height: 50px;
      font-size: 1.3em;
      text-align: center;
    }
  }

  .form {
    height: fit-content;
    width: 70.8vw;
    padding-top: 10vw;
    background-image: url("../assets/sinh/bgi-form.png");
    background-size: 100% 100%;
    position: relative;

    a {
      color: #00ffe6;
      text-align: center;
      display: block;
      padding-top: 2vw;
    }

    .form-input {
      width: 52.75vw;
      margin: 0 auto 3vw;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 5px 10px;
      background-size: 100% 100%;
      transition: all 0.25s ease;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 15px;

      img {
        margin-right: 10px;
      }

      .codeImg {
        cursor: pointer;
        width: 150px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 1px;
        .img {
          width: 150px;
          height: 100%;
          border-radius: 20px;
        }
      }

      input {
        font-family: UTMAvo;
        border: none;
        outline-width: 0;
        background-color: transparent;
        height: 7.29vw;
        font-size: 1em;
        color: #ffffff;
      }

      input::placeholder {
        color: #ffffff;
        font-size: 1em;
        font-style: normal;
        font-weight: normal;
      }
    }

    .btn {
      width: 45.33vw;
      height: 10vh;
      line-height: 7vh;
      text-align: center;
      margin: 0 auto;
      font-size: 1.5em;
      font-weight: bold;
      color: #ffffff;
      position: relative;
      top: 5vh;
      background-image: url("../assets/sinh/bgi-btn.png");
      background-size: 100% 100%;

      img {
        position: relative;
        top: 4px;
        width: 20vw;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sinh.vue